import {Modal, ModalFooter, ModalOverlay, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import {StyledModalHeader, StyledModalParagraph} from '@components/commons/delete-modal/style'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTranslation} from '@/translations/i18n'

export const DiscardAccessConfirmModal = ({
    count,
    isPending,
    onConfirm,
    onClose
}: {
    count: number
    isPending: boolean
    onConfirm: () => void
    onClose: () => void
}) => {
    const {t} = useTranslation()

    return (
        <>
            <ModalOverlay
                onClick={event => {
                    event.stopPropagation()
                    onClose()
                }}
            />
            <Modal width="400px" onClick={event => event.stopPropagation()}>
                <StyledModalHeader style={{border: 'none'}}>
                    <ModalTitle>{t('accesses:discard_access', {count})}</ModalTitle>
                    <StyledModalParagraph>{t('accesses:discard_access_confirm_description')}</StyledModalParagraph>
                </StyledModalHeader>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        {t('commons:cancel')}
                    </Button>
                    <Button variant="primaryDanger" disabled={isPending} onClick={onConfirm}>
                        {t('accesses:discard_access', {count})}
                        {isPending && <Spinner />}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
